import { IonApp, IonRouterOutlet, Platform } from "@ionic/angular/standalone";
import { Component, CUSTOM_ELEMENTS_SCHEMA, HostListener, Renderer2, OnInit, OnDestroy } from "@angular/core";
import { LocalizationService } from "./services/core/localize/localization.service";
import { CommonService } from "./services/common.service";
import { AppStateService } from "./services/init/app-state.service";
import { TranslateService } from '@ngx-translate/core';
import { WelcomeService } from "./services/core/optimisation/welcome.service";
import { NavigationExtras, Router, NavigationEnd } from "@angular/router";
import en from 'src/assets/i18n/en.json';
import hi from 'src/assets/i18n/hi.json';
import { storageKeys } from 'src/app/app.constants';
// import { AES256 } from "@awesome-cordova-plugins/aes-256/ngx";
import { register } from 'swiper/element/bundle';
import { environment } from "src/environments/environment";
import { PaymentDeeplinksService } from "./services/payment-deeplinks/payment-deeplinks.service";

register();
@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  imports: [
    IonApp,
    IonRouterOutlet
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'app';
  // private routerSubscription: any;
  private navigationHandled = false;
  @HostListener('document:click', ['$event'])
  documentClick(event: any) {
    let headers = document.querySelectorAll('.web-header');
    let body = document.body;
    if (headers?.length) {
      headers.forEach(rs => {
        if (!event.target.classList.contains('dropdown')) {
          rs.classList.remove('open');
          body.classList.remove('open')
        }
      });
    }
  }
  

  @HostListener("ionScroll", ['$event'])
  onWindowScroll() {
    let headers = document.querySelectorAll('.web-header');
    let body = document.body;
    if (headers?.length) {
      headers.forEach(rs => {
        rs.classList.remove('open');
        body.classList.remove('open')
      });
    }
  }
  

  
  constructor(
    private localizationService: LocalizationService,
    public commonServ: CommonService,
    public appState: AppStateService,
    private translate: TranslateService,
    private platform: Platform,
    private WelcomeService: WelcomeService,
    private router: Router,
    private paymentDeeplinksService: PaymentDeeplinksService,

  ) {
    this.setAppHeight();
    window.addEventListener('resize', this.setAppHeight);
    const params = new URLSearchParams(window.location.search)
    console.log("Query Params: ", params)
    if (Array.from(params).length > 0) {
      this.appState.loadAppData().then(() => this.paymentDeeplinksService.checkDeeplinks(params))
    }
    var url = window.location.href;
    // window.console.log = () => {}
    const endpoint = window.location.pathname.substring(1);
    console.log("endpoint", endpoint); // Output: "property"
    console.log("url from app component", url);
    if (url.split('?')[1]) {
      if(url?.includes("receive-benfit-otp"))
      {
        var transactionId = url.split('=')[1];
        this.router.navigate(['/receive-benfit-otp'], { queryParams: { transactionId: transactionId}});
      }
    }

    if (url.split('=')[1]&& !(url?.includes("/receive-benfit-otp"))) {
      console.log("url", url.split('=')[1]);
      var str= url.split('#')[1];
      console.log("str from app component", str);
      if(str?.includes("/hotel-specific-membership")){
        let navExtras: NavigationExtras = {
          state: {
            ccAvanue: true
          }
        }
      this.router.navigate(['/hotel-specific-membership'],navExtras);
      }else {
        // let appData = this.appState.getAppData();
        // console.log("uappDatarl", appData);
  
      }
      
    }
    // if (url?.includes('action') && !(url?.includes("/receive-benfit-otp"))) {
    //   this.deepLink(url);
    // }

  
    url = url?.includes("?") ? url?.split("?")[0] : url; //CC_AVENUE CHANGES
    let localUrl =  localStorage.getItem("pathUrl")    
    if ( (!storageKeys?.notRefreshingURLs.includes('/' + url.split('/')[url.split('/').length - 1])) && !(url?.includes("/receive-benfit-otp"))
       && !(url?.includes("/property")) && !(url?.includes("/promotion"))) {
      this.router.navigate(['/']);
    }
    if ( (!storageKeys?.notRefreshingURLs.includes('/' + url.split('/')[url.split('/').length - 1])) 
      && !(url?.includes("/receive-benfit-otp"))
       && !(url?.includes("/property")) && !(url?.includes("/promotion")) &&  !(url?.includes("/hotel-specific-membership")) ) {
      this.router.navigate(['/']);
    }
    if (localUrl?.includes("/buy-another/hotel-specific-membership") && url?.includes("/success.json")) {
      console.log("buy-another/hotel-specific-membership called");
      this.router.navigate(['/buy-another/hotel-specific-membership/success.json'],
        {
          queryParams: {
            pg: 'CCAvenue-BIN',
            ptype: 'Membership-Buy'
          }
        }); 
    } 
    else if (localUrl?.includes("/hotel-specific-membership") && !localUrl?.includes("/buy-another") && url?.includes("/success.json")) {
      console.log("hotel-specific-membership called");
      this.router.navigate(['/hotel-specific-membership/success.json'],
        {
          queryParams: {
            pg: 'CCAvenue-BIN',
            ptype: 'Membership-Buy'
          }
        });   
    }
    else if (localUrl?.includes("/gift-subscription-detail")  && url?.includes("/success.json")) {
      console.log("hotel-specific-membership called");
      this.router.navigate(['/gift-subscription-detail/success.json'],
        {
          queryParams: {
            pg: 'CCAvenue-BIN',
            ptype: 'Membership-Gift'
          }
        });   
    }
    // // let localUrl =  localStorage.getItem("url")
    // console.log(" url from hotel specific membership", url);
    // if( url && url.includes("success")){
    //     const match = url.match(/ptype=([^&]+)/);
    //     const ptype = match ? match[1] : null;
    //     console.log("pType ==>" , ptype);
    //     if(ptype == 'Buy-Another-Membership'){
    //       console.log("about to call the ccavenuePayment")    
    //       // this.ccAvanuePayment();  
    //     }else {
    //         console.log("else called from constructor and ccavenuepayment")
    //     }
  
    //   }

  
  
  
  

    // if(url.includes("tabs/home") && JSON.parse(localStorage.getItem(environment?.headers?.program_id + ":" + 'isLoggedIn')) ){
    //   console.log("url from app component with loggined", url);
    //   this.router.navigateByUrl('tabs/home');
    //           return;

    // }else {
    //   this.router.navigateByUrl('');
    // }

    var language = localStorage.getItem(environment?.headers?.program_id + ":" + "preferredLanguage");
    if (language) {
      this.translate.setDefaultLang(language);
      this.appState.preferredLanguage = language;

    } else {
      // to set detault language before getting the user language
      this.translate.setDefaultLang("en");
      this.appState.preferredLanguage = 'en'
      localStorage.setItem(environment?.headers?.program_id + ":" + "preferredLanguage", this.appState.preferredLanguage)
    }
    this.commonServ.updateTranslationFile();
    // return;
      // if (this.platform.is("android")) {
      //   /********  / Hidden Functionality Implemented For HardBack*/
      //   //  this.registerBackButton();
      //   /******** END  / Hidden Functionality Implemented For HardBack*/
      // }
     
      this.localizationService.setDefaultAppLanguage();
      this.platform.ready().then(() => {
        this.WelcomeService.initializeApp();
      })



  }
  //  getLocation() {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(showPosition);
  //   } else {
  //   
  //   }
  // }

  //  showPosition(position) {
  //  
  //   "<br>Longitude: " + position.coords.longitude);
  // }

  ngOnInit() {
    // Handle navigation after router is ready - works in both local and deployed environments
    this.router.initialNavigation();
    
    // Single, controlled navigation check
    setTimeout(() => {
      this.handleInitialNavigation();
    }, 1000);
  }

  ngOnDestroy() {
    // if (this.routerSubscription) {
    //   this.routerSubscription.unsubscribe();
    // }
  }

  private handleInitialNavigation() {
    // Prevent multiple navigation attempts
    if (this.navigationHandled) {
      return;
    }
    
    try {
      const isLoggedIn = JSON.parse(localStorage.getItem(environment?.headers?.program_id + ":" + "isLoggedIn") || 'false');
      const currentPath = window.location.pathname;
      
      console.log("Navigation check - isLoggedIn:", isLoggedIn, "currentPath:", currentPath);
      
      // Only redirect if user is logged in and on specific paths
      if (isLoggedIn) {
        if (currentPath === '/' || currentPath === '') {
          console.log("Redirecting authenticated user from root to /tabs/home");
          this.navigationHandled = true;
          this.router.navigateByUrl('/tabs/home');
          return;
        }
        
        if (currentPath === '/tabs') {
          console.log("Redirecting authenticated user from /tabs to /tabs/home");
          this.navigationHandled = true;
          this.router.navigateByUrl('/tabs/home');
          return;
        }
      }
      
      // Mark as handled even if no navigation was needed
      this.navigationHandled = true;
    } catch (error) {
      console.error("Error in navigation handling:", error);
      this.navigationHandled = true; // Prevent retries on error
    }
  }
  
  fetchTranslationData(currentLanguage: string) {
    switch (currentLanguage) {
      case 'en': return en;
      case 'hi': return hi;
      default: return en;
    }
  }

  private setAppHeight = () => {
    document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
  };


}


// $ ionic cordova plugin add ionic-plugin-deeplinks --variable URL_SCHEME=clubmarriott --variable DEEPLINK_SCHEME=https --variable DEEPLINK_HOST=clubmarriott.in --variable ANDROID_PATH_PREFIX=/
// $ npm install --save @ionic-native/deeplinks@5
/*********************

}
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

// echo export "ANDROID_HOME=/Users/tlc/Library/Android/sdk" >> ~/.bash_profile
// keytool -genkey -v -keystore tlc_Customer.keystore -alias tlc_Customer -keyalg RSA -keysize 2048 -validity 10000
// keytool -importkeystore -srckeystore tlc_Customer.keystore -destkeystore tlc_Customer.keystore -deststoretype pkcs12

// jarsigner -verbose -sigalg SHA1withRSA -digestalg SHA1 -keystore tlc_Customer.keystore /Users/kushal/Desktop/CustomerAppCode/tlc-customer-app-inhouse-development/platforms/android/app/build/outputs/apk/release/app-release-unsigned.apk tlc_Customer


// /Users/kushal/Library/Android/sdk/build-tools/29.0.2/zipalign -v 4 /Users/kushal/Desktop/CustomerAppCode/tlc-customer-app-inhouse-development/platforms/android/app/build/outputs/apk/release/app-release-unsigned.apk myProtectedApp.apk

// path/to/Android/sdk/build-tools/VERSION/zipalign
// export ANDROID_HOME="/Users/tlc/Library/Android/sdk"
// ionic cordova build ios --prod --release -- --developmentTeam="ABCD" --codeSignIdentity="iPhone Developer" --packageType="app-store"
// ionic cordova build ios --prod --release --buildConfig=build.json
// ionic cordova build ios --prod --release --buildConfig=build.json --device="Generic iOS Device"
// /Users/tlc/Desktop/AashishCode/FinalCode/tlc-customer-app-inhouse-development/platforms/android/app/build/outputs/apk/release/app-release-unsigned.apk
//"ionic:build:after": "jscrambler -c jscrambler.json"

// "ionic:build:after": "jscrambler -c jscrambler.json --code-hardening-threshold 50mb"


// jarsigner -verbose -sigalg SHA1withRSA -digestalg SHA1 -keystore tlc_Customer.keystore /Users/kapil2/Desktop/WelcomeByPass/tlc-customer-app-inhouse-development/platforms/android/app/build/outputs/apk/release/app-release-unsigned.apk tlc_Customer
// Mobiloitte@1

// /Users/kapil2/Library/Android/sdk/build-tools/30.0.3/zipalign -v 4 /Users/kapil2/Desktop/WelcomeByPass/tlc-customer-app-inhouse-development/platforms/android/app/build/outputs/apk/release/app-release-unsigned.apk myProtectedApp.apk


// "postbuild": "node ./scripts/jscrambler.js"

// "build": "ng build && ./scripts/jscrambler.sh"